import {
    IconBuildingTable, IconChipMultiplePerson,
    IconEmployeeInside, IconEmployeeOutside, IconEquipmentInside, IconEquipmentOutside} from "../../../../../components/buttons/IconButtons";
import {CARDS_MODEL} from "../Model/Model";
import React, {useState} from "react";
import {POSITION_MODEL} from "../../../../../Helpers/PositionModel";
import CustomUserChip from "../../../../../components/CustomUserChip";
import RenderExpandedRow from "../SubComponent/RenderExpandedRow";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 26 de noviembre de 2025
 *
 * Custom hook that manages all logic for incoming contractors:
 * search filters, WebSocket synchronization, modal states,
 * active employee lists, and date-range-based payloads.
 *

 */
export const IncomingContractorsBodyApp = ({
                                               t,
                                               withSearchActiveContractors,
                                               withSearchEmployeeInside,
                                               withSearchEmployeeOutside,
                                               withSearchEquipmentInside,
                                               withSearchEquipmentOutside,
                                               showCheckInModal,
                                               setShowCheckInModal,
                                               showCheckOutModal,
                                               setShowCheckOutModal,
                                               showLogModal,
                                               setShowLogModal,
                                               setItemSelected,
                                               setOutLog
}) => {
    const [expandedRowId, setExpandedRowId] = useState(null);

    const handleRowExpand = (row) => {
        if (row?.id !== expandedRowId) {
            setExpandedRowId(row?.id);
        }
    };

// Columns for the table; each one of these is a column and contains its information
    const columns = [
        {
            key: CARDS_MODEL.ACTIVE_CONTRACTORS,
            title: 'active_contractors',
            tooltip: 'active_contractors_info',
            items: withSearchActiveContractors
        },
        {
            key: CARDS_MODEL.EMPLOYEE_INSIDE,
            title: 'employee_inside',
            tooltip: 'employee_inside_info',
            items: withSearchEmployeeInside,
            icon: IconEmployeeInside,
            leftButton: 'check_out',
            rightButton: 'view_log',
            leftButtonAction: () => setShowCheckOutModal(true),
            rightButtonAction: () => {
                setShowLogModal(true);
                setOutLog(false);
            }
        },
        {
            key: CARDS_MODEL.EMPLOYEE_OUTSIDE,
            title: 'employee_outside',
            tooltip: 'employee_outside_info',
            items: withSearchEmployeeOutside,
            icon: IconEmployeeOutside,
            button: 'view_log',
            buttonAction: () => {
                setShowLogModal(true);
                setOutLog(true);
            }
        },
        {
            key: CARDS_MODEL.EQUIPMENT_INSIDE,
            title: 'equipment_material_inside',
            tooltip: 'equipment_material_inside_info',
            items: withSearchEquipmentInside,
            icon: IconEquipmentInside
        },
        {
            key: CARDS_MODEL.EQUIPMENT_OUTSIDE,
            title: 'equipment_material_outside',
            tooltip: 'equipment_material_outside_info',
            items: withSearchEquipmentOutside,
            icon: IconEquipmentOutside
        }
    ];

    const expandableColumns = [
        {
            field: 'company',
            label: 'company',
            className: 'py-16px pl-16px',
            classNameContainerTooltip : 'w-220px gap-2 d-flex justify-content-start align-items-center flex-grow-1 minw-0',
            classNameSubTextTooltip: 'ibl-font-w-400 w-50px',
            render: (value, row) => {
                return {
                    icon: <span className={'pr-2'}><IconBuildingTable className={'w-18px h-18px'}/></span>,
                    text:  row?.companyName,
                    subText: row?.folio,
                    subChip :
                        <CustomUserChip
                            className='my-1 chip-shades-300-00'
                            name={row?.employees?.length}
                            Icon={IconChipMultiplePerson}
                            showAvatar={true}
                            classNameText={"ibl-font-w-600"}
                            variant="large"
                            iconPosition={POSITION_MODEL.LEFT}
                            classNameIcon={'icon-color-text-950 p-0 m-0'}
                            classNameAvatar={"w-16px h-16px"}
                        />
                }
            }},
    ];

    const renderExpandedRow = ({ row }) => {
        return <RenderExpandedRow
            row={row}
            onCheckIn={(item) => {
                setShowCheckInModal(true)
                setItemSelected({
                    userId: item.id,
                    userFullName: item.name,
                    companyName: row?.companyName,
                    contractorId: row?.contractorId
                })
            }}
        />
    };

    return {
        columns,
        showCheckInModal,
        setShowCheckInModal,
        showCheckOutModal,
        setShowCheckOutModal,
        showLogModal,
        setShowLogModal,
        handleRowExpand,
        expandableColumns,
        renderExpandedRow
    };
};
